/**
 * State encoding and decoding utilities
 * Handles JSON serialization, URL encoding, and base64 encoding of state data
 */

/**
 * Creates an encoded state string from parameters
 * @param {Object} params - Object containing state parameters
 * @returns {string} - Base64 encoded state string
 */
export function createEncodedState(params) {
  if (!params || typeof params !== 'object') {
    throw new Error('Parameters must be a valid object');
  }

  const jsonString = JSON.stringify(params);
  const encodedString = encodeURIComponent(jsonString);
  const base64String = btoa(encodedString);

  return base64String;
}

/**
 * Decodes a state string back to parameters object
 * @param {string} encodedState - Base64 encoded state string
 * @returns {Object} - Decoded parameters object
 */
export function decodeState(encodedState) {
  if (!encodedState || typeof encodedState !== 'string') {
    throw new Error('Encoded state must be a valid string');
  }

  try {
    const decodedBase64 = atob(decodeURIComponent(encodedState));
    const decodedUri = decodeURIComponent(decodedBase64);
    const params = JSON.parse(decodedUri);

    return params;
  } catch (error) {
    throw new Error(`Failed to decode state: ${error.message}`);
  }
}
